<template>
  <div class="indexbox">
    <div class="iboxleft">
      <div class="iboxtit"><slot name="indextit"></slot></div>
      <div class="iboxcon"><slot name="indexnum"></slot></div>
      <div class="iboxbottom">
        <div class="ibttol"><slot name="indextit1"></slot></div>
        <div class="ibttor"><slot name="indexnum1"></slot></div>
      </div>
    </div>
    <div class="iboxright">
      <slot name="indeximg"></slot>
      <!-- <img src="@/assets/m/home/1.png" /> -->
    </div>
  </div>
</template>

<script>
import { GetHomeData } from "../../assets/server/api.js";
export default {
  props: ["tpsCount"],
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {
    if (this.Time) {
      clearInterval(this.Time);
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.indexbox {
  width: 702px;
  height: 208px;
  background: #000000;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  margin: 0 auto;
  display: flex;
  margin-bottom: 24px;
  justify-content: space-between;
  .iboxleft {
    margin-left: 24px;
    .iboxtit {
      margin-top: 24px;
      height: 34px;
      text-align: left;
      font-size: 24px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #8a8a8a;
      line-height: 34px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .iboxcon {
      height: 62px;
      font-size: 44px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 62px;
      margin-bottom: 24px;
      margin-top: 2px;
      text-align: left;
    }
    // .iboxcon:hover{
    //   color: #00e79a;
    // }
    .iboxbottom {
      display: flex;
      .ibttol {
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #00e79a;
        line-height: 34px;
      }
      .ibttor {
        margin-left: 16px;
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        line-height: 34px;
      }
    }
  }
  .iboxright {
    margin-right: 24px;
    img {
      margin-top: 64px;
      width: 84px;
      height: 84px;
    }
  }
}
</style>
